import * as firebase from 'firebase';
import DF from 'dateformat';

const FB_CONFIG_PROD = {
  apiKey: "AIzaSyBrCVNOGoel5JIjwTuAc0xOpTW6y58YcN4",
  authDomain: "screener-c9321.firebaseapp.com",
  databaseURL: "https://screener-c9321.firebaseio.com",
  projectId: "screener-c9321",
  storageBucket: "screener-c9321.appspot.com",
  messagingSenderId: "33013256037"
};
const FB_CONFIG_DEV = {
  apiKey: "AIzaSyB2ApII7FxSTUKDQou5bo_3FsKgY60RIes",
  authDomain: "screener-dev.firebaseapp.com",
  databaseURL: "https://screener-dev.firebaseio.com",
  projectId: "screener-dev",
  storageBucket: "screener-dev.appspot.com",
  messagingSenderId: "617902889739"
};

class FirebaseWrapper {
  constructor() {
    // Initialize Firebase
    var isProd = process.env.NODE_ENV === "production" && !(window.location.href.includes('staging')|| window.location.href.includes('uat') || window.location.href.includes('dev'));
    var config = isProd ? FB_CONFIG_PROD : FB_CONFIG_DEV;
    firebase.initializeApp(config);
    this.submissions = firebase.database().ref().child("submissions");
    this.submission_count = firebase.database().ref().child("submission_count");
    this.subscribers = firebase.database().ref().child("subscribers");
    this.tokens = firebase.database().ref().child("tokens");
  }

  getFirebase() {
    return firebase;
  }

  getFirebaseAuth() {
    return firebase.auth();
  }

  getCurrentUser() {
    return firebase.auth().currentUser;
  }

  onAuthStateChanged(callback) {
    return firebase.auth().onAuthStateChanged(user => callback(user));
  }

  handleGoogleLogin(callback) {
    var provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithRedirect(provider);
  }

  handleFacebookLogin(callback) {
    var provider = new firebase.auth.FacebookAuthProvider();
    firebase.auth().signInWithRedirect(provider);
  }

  handleSignOut() {
    firebase.auth().signOut().then(function() {
      console.log("success! - signed out");
    }).catch(function(error) {
      console.log("failed to signed out!");
    });
  }

  getDateKey() {
    var now = new Date();
    var today_utc = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
    return DF(today_utc, "yyyymmdd");
  }

  submitResponse(message, email, subscribed) {
    var dateKey = this.getDateKey();
    message.submissionDate = dateKey;
    var submissionKey = this.submissions.push(message).key;
    var submission_count_today = this.submission_count.child(dateKey);
    submission_count_today.transaction(
      function(count) {
          if (count) {
              return count + 1;
          }
          return 1;
      },
      function(error, committed, currentData) {
        console.log(error + " " + committed + " " + currentData);
      }
    );
		if (subscribed) {
			this.addSubscriber(email, submissionKey);
		}
    return submissionKey;
  }

  submitRobinhoodToken(accountID, token) {
    var submission = {};
    submission[accountID] = token;
    return this.tokens.update(submission);
  }

  fetchRobinhoodToken(accountID, callback) {
    this.tokens.orderByKey().equalTo(accountID)
      .on("value", res => {
        const data = res.val() || {};
        callback(data[accountID]);
      });
  }

  appendEmailAddress(submissionKey, email) {
    var dateKey = this.getDateKey();
    var submission = this.submissions.child(dateKey).child(submissionKey);
    submission.update({email});
    return email;
  }

  addSubscriber(subscriber_email) {
    if (subscriber_email) {
      var key = subscriber_email.replace(".", ",");
      var la = this.subscribers.child(key);
      la.set({email : subscriber_email});
    }
  }

  checkLimit(callback) {
    var submission_count_today = this.submission_count.child(this.getDateKey());
    submission_count_today.once('value').then(function(res) {
      callback(res.val());
    });
  }

  fetchSubmissionsByDate(date_utc, callback) {
    this.submissions.orderByChild("submissionDate").equalTo(date_utc).on("child_added", function(submission) {
      callback({key:submission.key, value:submission.val()});
    });
  }

  fetchSubmissionsByEmail(email, callback) {
    this.submissions.off();
    this.submissions.orderByChild("email").equalTo(email)
      .on("value", data => callback(data));
  }
}
var FbWrapper = new FirebaseWrapper();

export default FbWrapper;



// WEBPACK FOOTER //
// ./src/lib/FirebaseWrapper.js